<template>
  <div id="shirt" :style="'height:' + shirtHeight">
    <svg
      ref="svg"
      :height="svgHeight"
      :width="svgWidth"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :viewBox="viewBox"
    />
  </div>
</template>
<script>
export default {
  name: "Shirt",
  props: [
    "primary_color",
    "type",
    "secondary_color",
    "number",
    "view_box",
    "svg_height",
    "svg_width",
    "shirt_height",
    "sport"
  ],
  data() {
    return {
      viewBox: "10 0 500 500",
      svgHeight: "100px",
      svgWidth: "100px",
      shirtHeight: "95px"
    };
  },
  created() {
    // check if isset view_box param
    if (typeof this.view_box !== "undefined") {
      this.viewBox = this.view_box;
    }
    // check if isset svg_height
    if (typeof this.svg_height !== "undefined") {
      this.svgHeight = this.svg_height;
    }
    // check if isset svg_width
    if (typeof this.svg_width !== "undefined") {
      this.svgWidth = this.svg_width;
    }
    // check if isset shirt_height
    if (typeof this.shirt_height !== "undefined") {
      this.shirtHeight = this.shirt_height;
    }
  },
  mounted() {
    this.draw();
  },
  watch: {
    primary_color: function() {
      this.draw();
    },
    type: function() {
      this.draw();
    },
    secondary_color: function() {
      this.draw();
    },
    number: function() {
      this.draw();
    }
  },
  methods: {
    draw() {
      // remove svg childs
      while (this.$refs.svg.firstChild) {
        this.$refs.svg.removeChild(this.$refs.svg.firstChild);
      }

      if (this.sport == "football") {
        this.football();
      }

      if (this.sport == "basketball") {
        this.basketball();
      }
    },

    football() {
      // create polygon element
      let polygon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "polygon"
      );
      polygon.setAttribute(
        "points",
        "357.344,49.996 326,51.332 280.672,105.996 256,109.996 226.672,106.668 182,45.996 11.664,123.004 47.664,235.004 112.328,217.668 119,457.668 389.656,457.668 393.656,214.332 464.328,241.668 500.328,131.668 "
      );

      // check if isset primary color
      polygon.setAttribute(
        "fill",
        this.primary_color && this.primary_color != ""
          ? this.primary_color
          : "#FFFFFF"
      );
      this.$refs.svg.appendChild(polygon);

      if (
        this.type != "" &&
        this.primary_color != this.secondary_color &&
        this.secondary_color != ""
      ) {
        switch (this.type) {
          case "vertical_stripes":
            this.drawPolygon(
              "155,64 184,64 155,448 184,448 155,64 155,448 184,64 184,448"
            );
            this.drawPolygon(
              "240,116 270,116 240,448 270,448 240,116 240,448 270,116 270,448"
            );
            this.drawPolygon(
              "357,64 328,64 357,448 328,448 357,64 357,448 328,64 328,448"
            );
            break;
          case "horizontal_stripes":
            this.drawPolygon(
              "485,138 475,167 27,138 37,167 485,138 27,138 475,167 37,167"
            );
            this.drawPolygon(
              "383,223 383,252 129,223 129,252 383,223 129,223 383,252 129,252"
            );
            this.drawPolygon(
              "383,308 383,337 129,308 129,337 383,308 129,308 383,337 129,337"
            );
            this.drawPolygon(
              "383,393 383,422 129,393 129,422 383,393 129,393 383,422 129,422"
            );
            break;
          case "diagonal_strip":
            this.drawPolygon(
              "358,64 384,80 128,448 160,448 358,64 128,448 384,80 160,448"
            );
            break;
          case "inverted_chevron":
            this.drawPolygon(
              "128,80 98,97 256,200 256,250 128,80 256,200 98,97 256,250"
            );
            this.drawPolygon(
              "384,80 414,97 256,200 256,250 384,80 256,200 414,97 256,250"
            );
            break;
          case "arlequine":
            this.drawPolygon(
              "135,64 200,64 135,270 200,270 135,64 135,270 200,64 200,270"
            );
            this.drawPolygon(
              "250,100 250,270 115,70 115,270 250,100 115,70 250,270 115,270"
            );
            this.drawPolygon(
              "400,270 400,450  250,450 250,270 400,270 250,450"
            );
            break;
        }
      }

      // create path
      let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute(
        "d",
        "M362.672,42.66h-53.328c0,29.414-23.938,53.336-53.344,53.336s-53.328-23.922-53.328-53.336h-53.336L0,127.996 l42.672,117.336l64-21.336V469.34h298.672V223.996l64,21.336L512,127.996L362.672,42.66z M456.375,218.527l-44.297-14.766 L384,194.395v29.602v224H128v-224v-29.602l-28.078,9.367l-44.297,14.766l-29.43-80.93L155,63.996h29.43 c9.18,30.844,37.75,53.336,71.57,53.336c33.828,0,62.391-22.492,71.562-53.336H357l128.812,73.602L456.375,218.527z"
      );
      this.$refs.svg.appendChild(path);
    },

    basketball() {
      // create polygon element
      let polygon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "polygon"
      );
      polygon.setAttribute(
        "points",
        "405 193, 360 154, 356 54, 370 50, 339 36, 328 37, 323 86, 255 121, 188 86, 182 37, 171 36, 140 50, 134 64, 149 104, 135 193, 101 202, 101 424, 108 435, 255 468, 402 435, 409 424, 409 202, 405 193"
      );

      // check if isset primary color
      polygon.setAttribute(
        "fill",
        this.primary_color && this.primary_color != ""
          ? this.primary_color
          : "#FFFFFF"
      );
      this.$refs.svg.appendChild(polygon);

      if (
        this.type != "" &&
        this.primary_color != this.secondary_color &&
        this.secondary_color != ""
      ) {
        switch (this.type) {
          case "vertical_stripes":
            this.drawPolygon(
              "155,64 184,64 155,448 184,448 155,64 155,448 184,64 184,448"
            );
            this.drawPolygon(
              "240,116 270,116 240,448 270,448 240,116 240,448 270,116 270,448"
            );
            this.drawPolygon(
              "357,64 328,64 357,448 328,448 357,64 357,448 328,64 328,448"
            );
            break;
          case "horizontal_stripes":
            this.drawPolygon(
              "400,200 400,250 115,200 115,250 400,200 115,200 400,250 115,250"
            );
            this.drawPolygon(
              "400,300 400,350 115,300 115,350 400,300 115,300 400,350 115,350"
            );
            this.drawPolygon(
              "400,393 400,430 115,393 115,430 400,393 115,393 400,430 115,430"
            );
            break;
          case "diagonal_strip":
            this.drawPolygon(
              "335,50 365,80 105,420 145,435 335,50 105,420 365,80 145,435"
            );
            break;
          case "inverted_chevron":
            this.drawPolygon(
              "150,80 140,115 256,200 256,250 150,80 256,200 140,115 256,250"
            );
            this.drawPolygon(
              "360,80 370,115 256,200 256,250 360,80 256,200 370,115 256,250"
            );
            break;
        }
      }

      // create path
      let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute(
        "d",
        "M405.3026637316112,192.81337348669908 c-21.45868286452732,-19.846107288317274 -34.270405355833866,-53.216581195616605 -34.270405355833866,-89.26621609961134 c0,-13.576743581595169 1.8157347039215426,-26.856684375049316 5.391652787781014,-39.4700092807001 c1.5982909500428262,-5.631317071253175 -1.1348341899509644,-11.5880061829818 -6.447127943469672,-14.049723425798508 l-30.513548673856338,-14.140192724857537 c-3.6187719623611163,-1.6776499843051316 -7.842259765800996,-1.430049797406739 -11.246762335653889,0.6650287071181178 c-3.4013282084823997,2.0934913238396105 -5.52338878465644,5.751942803331881 -5.6551247815318675,9.74370222672583 c-1.2062573207870388,36.554358361903006 -30.80876428131212,65.18868510442796 -67.39486625692004,65.18868510442796 S188.97945941667876,82.84873407079328 187.7763764572622,46.29437570889028 c-0.13173599687542675,-3.9917594233939506 -2.255383753734713,-7.6502109028862195 -5.6551247815318675,-9.74370222672583 c-3.4029153891676462,-2.095078504524857 -7.626403192607526,-2.3426786914232487 -11.246762335653889,-0.6650287071181178 L140.3609406662201,50.02583749990387 c-5.310706572833462,2.461717242816707 -8.043831712827252,8.416819173860087 -6.447127943469672,14.048136245113263 c3.579092445229963,12.614912086336032 5.391652787781014,25.896440060475424 5.391652787781014,39.471596461385346 c0,36.05122208467999 -12.811722491306545,69.42328317266457 -34.270405355833866,89.26621609961134 c-2.4363223518527692,2.252209392364221 -3.8219310900726167,5.421809220800689 -3.8219310900726167,8.739016852965046 v222.86873746088736 c0,4.615521432695669 2.6680507318987,8.815201525856859 6.845510295466444,10.776956852821042 c45.72826272262549,21.45868286452732 96.5974036847631,32.80226322198122 147.1110161734056,32.80226322198122 s101.3827534507801,-11.341993176768655 147.1110161734056,-32.80226322198122 c4.17904674425299,-1.960168146278938 6.845510295466444,-6.159848239440128 6.845510295466444,-10.776956852821042 V201.5523903396641 C409.12618200236903,198.23359552681453 407.7405732641492,195.06717005974855 405.3026637316112,192.81337348669908 zM385.3184717236775,416.7598066328685 c-40.784194888083874,17.96529817630065 -85.61570052354531,27.43283096379365 -130.14881619018047,27.43283096379365 s-89.36462130209661,-9.467532787493006 -130.14881619018047,-27.43283096379365 V206.5726428470975 c23.936271914196485,-24.510831322255573 38.09233644590648,-62.56507543171615 38.09233644590648,-103.02548546000982 c0,-12.270493877637627 -1.2824419936788518,-24.356874795786702 -3.8187567287021253,-36.05439644605048 l6.869318005745136,-3.183884454603683 c9.158032553870015,40.94450013729373 45.418762489002496,70.98189460557624 89.005918467231,70.98189460557624 c43.585568797543246,0 79.84788591336097,-30.037394468282507 89.00750564791625,-70.98189460557624 l6.8677308250598905,3.183884454603683 c-2.5379019157085203,11.697521650263782 -3.8187567287021253,23.782315387727614 -3.8187567287021253,36.05439644605048 c0,40.458822847608424 14.156064531709998,78.51465413775425 38.09233644590648,103.02548546000982 V416.7598066328685 z"
      );
      this.$refs.svg.appendChild(path);
    },

    drawPolygon(points) {
      var polygon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "polygon"
      );
      polygon.setAttribute("points", points);
      polygon.setAttribute(
        "fill",
        this.secondary_color && this.secondary_color != ""
          ? this.secondary_color
          : "#FFFFFF"
      );
      polygon.setAttribute(
        "stroke",
        this.secondary_color && this.secondary_color != ""
          ? this.secondary_color
          : "#FFFFFF"
      );
      this.$refs.svg.appendChild(polygon);
    }
  }
};
</script>
<style lang="scss" scoped>
#shirt {
  text-align: center;
  overflow: hidden;
}
</style>
